import { render, staticRenderFns } from "./SupplementaryUnitsSection.vue?vue&type=template&id=4772cb1c&scoped=true&"
import script from "./SupplementaryUnitsSection.vue?vue&type=script&lang=js&"
export * from "./SupplementaryUnitsSection.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryUnitsSection.vue?vue&type=style&index=0&id=4772cb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772cb1c",
  null
  
)

export default component.exports